@if (notifications.length) {
<div id="merchant-setup-notifications" tabindex="-1" class="card border-0 shadow-sm rounded-3 mb-4 at-dashboard-notifications">
  <div class="card-body p-4">
    <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
      <div>
        <h2 class="h5 mb-1 fw-semibold text-dark d-flex align-items-center gap-2 flex-wrap">
          <span
            class="mdi mdi-bell-ring-outline fs-5 text-primary at-dashboard-notifications-heading-icon flex-shrink-0"
            aria-hidden="true"
          ></span>
          <span>Notifications</span>
        </h2>
        <p class="text-muted mb-0 small">Next steps to get the most out of AtomicTax.</p>
      </div>
    </div>

    <ul class="list-group list-group-flush rounded-3 border at-dashboard-notifications-list">
      @for (n of notifications; track n.notification_id) {
      <li
        class="list-group-item list-group-item-action at-dashboard-notification-row d-flex gap-3 py-3 px-3"
        tabindex="0"
        role="button"
        [class.at-dashboard-row-unread]="!n.is_read"
        (click)="onNotificationClick(n)"
      >
        <span class="at-dashboard-icon mdi flex-shrink-0 align-self-start d-inline-flex rounded-3" [ngClass]="merchantNotifications.mdiIcon(n)" aria-hidden="true"></span>
        <div class="flex-grow-1 min-width-0">
          @if (n.title) {
          <div class="fw-semibold text-dark mb-1">{{ n.title }}</div>
          }
          @if (n.message) {
          <div class="small text-secondary mb-2 at-dashboard-msg">{{ n.message }}</div>
          }
          @if (n.displayTime) {
          <div class="small text-muted text-uppercase" style="letter-spacing: 0.04em; font-size: 0.6875rem;">{{ n.displayTime }}</div>
          }
        </div>
        <span class="mdi mdi-chevron-right text-muted flex-shrink-0 align-self-center small" aria-hidden="true"></span>
      </li>
      }
    </ul>
  </div>
</div>
}
